/**
 * Created by mnaughton on 10/15/2015.
 */

/**
 * A base class for field editors.
 * @type app/views/Field/BaseFieldView
 * @extends Backbone.View
 */
import Backbone from "backbone";
import _ from "underscore";
import $ from "jquery";
export default Backbone.View.extend({
  /**
   * Initializes the view.
   * @param {Object} options The options hash.
   * @param {app/Field} options.field The field associated with this view.
   * @param {app/Context} options.context The context associated with this view.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options);

    var self = this;

    if (!_.isUndefined(this.options.value)) {
      this._value = this.options.value;
    }

    Object.defineProperty(this, "value", {
      get: function () {
        return self.getValue();
      },
      set: function (value) {
        return self.setValue(value);
      },
    });

    Object.defineProperty(this, "field", {
      get: function () {
        return self.options.field;
      },
    });
  },

  /**
   * Event handler to be invoked whenever the value of the view changes in a non-programmatic fashion.
   *
   * Internally, triggers the `change` event, passing the result of `this.getValue()`.
   */
  onChange: function () {
    this._value = this.getControlValue();
    this.trigger("change", this.getValue());
  },

  /**
   * Gets the variables to be passed to the template on render.
   * @param {Object} [seed] A hash from which to derive values. By default, this is `this.options`.
   * @return {Object} The hash of variables to pass to the template. By default this is `seed` combined with an additional `value` property.
   */
  serialize: function (seed) {
    return _.extend({}, seed || {}, {
      value: this.value,
    });
  },

  render: function () {
    if (!this.rendering) {
      this.rendering = true;

      var self = this;
      var load = (this.load = this.startLoad());

      if (load.state() == "pending") {
        this.$el.html(this.loadingTemplate(this.serialize(this.options)));
      }

      load
        .done(function (options) {
          self.$el.html(self.template(self.serialize(options)));
        })
        .fail(function (err) {
          self.renderError(err);
        })
        .always(function () {
          self.delegateEvents();
          self.postRender();

          if (!_.isUndefined(self.options.value)) {
            self.value = self.options.value;
          }

          self.rendering = false;
        });
    }
  },

  /**
   * A reference to the most recent result from `startLoad`, which is called in render.
   * @type Promise
   */
  load: null,

  /**
   * Replace the view contents with error information.
   * @param err The error object to be passed to the `errorTemplate`.
   */
  renderError: function (err) {
    this.$el.html(this.errorTemplate(err));
  },

  /**
   * Called after the template has been rendered.
   */
  postRender: function () {},

  /**
   * Gets the value contained in this editor. It is required that this value can be passed to `setValue` to return the editor to the same state.
   * @param [defaultValue] The default value to return if there is no value set.
   * @return The value.
   */
  getValue: function (defaultValue) {
    if (this._value === false) {
      return this._value;
    } else if (this._value === "") {
      return this._value;
    }

    return this._value || defaultValue;
  },

  /**
   * Gets the currently-rendered value.
   * @return The value.
   */
  getControlValue: function () {},

  /**
   * Sets the currently-rendered value.
   * @param value The value.
   */
  setControlValue: function (value) {},

  /**
   * Initiates the loading of any additional data.
   * @return Promise Resolves with the items to send to `serialize`, or rejects with an error message.
   */
  startLoad: function () {
    return $.when(this.options);
  },

  /**
   * Renders the HTML to display while the data source is loading, if applicable.
   * @type Function
   */
  loadingTemplate: _.template(
    '<span class="field-loading">Loading Items...</span>'
  ),

  /**
   * Renders the HTML to display if an error occurs while the data source is loading, if applicable.
   * @param err The error object.
   * @type Function
   */
  errorTemplate: _.template(
    '<span class="field-error">Error loading items.</span>'
  ),

  /**
   * Sets the value contained in this editor.
   * @param value
   */
  setValue: function (value) {
    this._value = value;
    this.setControlValue(value);
  },

  delegateEvents: function (events) {
    Backbone.View.prototype.delegateEvents.apply(this, arguments);
    this.postRender();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/BaseFieldView.js
// module id = 33
// module chunks = 1